import { useEffect, useState } from 'react'
import { mergePublic } from '../services/store'
import { fetchPublicLanding } from '../services/landingService'
import { fetchPublicForm, fetchPublicFormById } from '../services/formService'
import { fetchPublicOrganization } from '../services/organizationService'

/**
 * Descarga una landing publicada (y su formulario y marca) para un visitante
 * anónimo, y la vuelca en la caché para que las vistas la lean igual que
 * cuando hay sesión iniciada.
 */
export function usePublicLanding(slug: string): boolean {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    setLoading(true)
    fetchPublicLanding(slug)
      .then(async (landing) => {
        if (!active || !landing) return
        const [form, organization] = await Promise.all([
          landing.formId ? fetchPublicFormById(landing.formId) : null,
          fetchPublicOrganization(landing.organizationId),
        ])
        if (!active) return
        mergePublic({
          landings: [landing],
          forms: form ? [form] : [],
          organizations: organization ? [organization] : [],
        })
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [slug])

  return loading
}

/** Descarga un formulario público activo por su slug. */
export function usePublicForm(slug: string): boolean {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    setLoading(true)
    fetchPublicForm(slug)
      .then(async (form) => {
        if (!active || !form) return
        const organization = await fetchPublicOrganization(form.organizationId)
        if (!active) return
        mergePublic({
          forms: [form],
          organizations: organization ? [organization] : [],
        })
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [slug])

  return loading
}
